var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(_vm._s(_vm.name)+" "),_c('AdaButton',{attrs:{"type":"createButton","title":"NEUE KAMPAGNE","to":"/campaigns/create"}}),_c('XXLCheckbox',{attrs:{"labelDetail":"Platzierung","label":"Run of Channel","initial":"true"},on:{"change":_vm.change}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }